module.exports = __webpack_public_path__ + "static/media/gifts.f12b5e84.jpg";